import { createSlice, current } from '@reduxjs/toolkit';
import {
	getWaterFlowRateList,
	getWaterFlowRateListItem,
	addNewWaterFlowRateList,
	updateWaterFlowRateList,
	deleteWaterFlowRateList,
} from './thunk';

export const initialState = {
	itemWaterFlowRateListList: [],
	itemWaterFlowRateList: null,
	isWaterFlowRateListLoading: false,
	isWaterFlowRateListSuccess: false,
	dataWaterFlowRateList: null,
	statementList: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const WaterFlowRateListSlice = createSlice({
	name: 'WaterFlowRateList',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		clearWaterFlowRateList(state) {
			state.itemWaterFlowRateListList = [];
			state.statementList = [];
		},
	},
	extraReducers: builder => {
		builder.addCase(getWaterFlowRateList.pending, state => {
			state.isLoadingList = true;
			state.isWaterFlowRateListSuccess = false;
		});

		builder.addCase(getWaterFlowRateList.fulfilled, (state, action) => {
			let statementList = action.payload;

			state.itemWaterFlowRateListList = statementList;
			state.statementList = statementList;
			state.isLoadingList = false;
			state.isWaterFlowRateListSuccess = true;
		});

		builder.addCase(getWaterFlowRateList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWaterFlowRateListSuccess = false;
		});

		builder.addCase(getWaterFlowRateListItem.pending, state => {
			state.isWaterFlowRateListLoading = true;
			state.isWaterFlowRateListSuccess = false;
		});

		builder.addCase(getWaterFlowRateListItem.fulfilled, (state, action) => {
			state.itemWaterFlowRateList = action.payload;
			state.isWaterFlowRateListLoading = false;
			state.isWaterFlowRateListSuccess = true;
		});

		builder.addCase(getWaterFlowRateListItem.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isWaterFlowRateListLoading = false;
			state.isWaterFlowRateListSuccess = false;
		});

		builder.addCase(addNewWaterFlowRateList.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewWaterFlowRateList.fulfilled, (state, action) => {
			state.itemWaterFlowRateListList.push(action.payload);
			state.statementList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewWaterFlowRateList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateWaterFlowRateList.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateWaterFlowRateList.fulfilled, (state, action) => {
			state.itemWaterFlowRateListList = state.itemWaterFlowRateListList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(updateWaterFlowRateList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWaterFlowRateList.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteWaterFlowRateList.fulfilled, (state, action) => {
			state.itemWaterFlowRateListList = current(state.itemWaterFlowRateListList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.statementList = current(state.statementList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDeleteError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteWaterFlowRateList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDeleting = false;
			state.isDeleteError = true;
		});
	},
});

export const { setRequireCloseModal, clearWaterFlowRateList } = WaterFlowRateListSlice.actions;

export default WaterFlowRateListSlice.reducer;
